// extracted by mini-css-extract-plugin
export default {"horizontalTabs":"horizontalTabs-AMV4PFjq","measureOnly":"measureOnly-_0ty7u_1","tab":"tab-Wb8QMT0Z","active":"active-mE8uOVrH","sm":"sm-gf8ZRQwp","md":"md-J7SBKEMr"};